/**
 * Created by lihanying on 2017/6/21.
 */


export const GETSCANSUCCESS = 'GETSCANSUCCESS'


// WEBPACK FOOTER //
// ./src/containers/WechatAuth/constants.js